'use client'

import { PhiMask } from '@/components/PhiMask'
import { useTenantSafe } from '../TenantLayout/Client'

const DEFAULT_NAME = 'Ash'

export function TenantName() {
  const ctx = useTenantSafe()
  const name = ctx?.tenant?.name || DEFAULT_NAME

  return (
    <PhiMask as="span" className="inline" maskPosthog={false}>
      <span data-testid="tenant-name">{name}</span>
    </PhiMask>
  )
}
